import script from "./AddUserView.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUserView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__